<template>
  <div class="subsector wastewater">
    <div class="parent-sector">
      <p>Waste</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-sm-6">
          <h1>Wastewater</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Wastewater originates from a variety of residential, commercial,
                and industrial sources. It can be a source of CH₄ when organic
                material present in the wastewater-flows decomposes under
                anaerobic conditions. Developed countries rely on centralized
                aerobic wastewater treatment systems that limit CH₄ generation,
                while developing countries often rely on a broader suite of
                wastewater treatment technologies. N₂O emissions occur primarily
                as indirect emissions from wastewater after disposal of effluent
                into waterways, lakes, or the sea.
              </p>
              <p>
                Global wastewater emissions are projected to increase modestly
                on an annual basis at a rate of less than 1% per year from 2015
                through 2030. Projected emissions reflect population growth and
                an increasing contribution of emissions from fast growing urban
                populations.
              </p>
              <p>
                The global abatement potential of CH₄ from wastewater treatment
                is 122 MtCO₂e in 2015 and rises to 251 MtCO₂e in 2030. High-cost
                abatement measures from wastewater treatment significantly
                constrain the abatement achievable at lower prices.
                Cost-effective emission reductions, or reduction at prices below
                $0, are limited to 2 MtCO₂e, less than 1% of BAU emissions in
                2030.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartWastewater1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartWastewater2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartWastewater1 from "@/components/waste/ChartWastewater1";
import ChartWastewater2 from "@/components/waste/ChartWastewater2";

export default {
  components: {
    ChartWastewater1,
    ChartWastewater2
  },
  data() {
    return {
      currentComp: "ChartWastewater1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-brown-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #4c300e;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
